// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__1Dij2"};